// extracted by css-extract-rspack-plugin
export default {"cls1":"PremiumCtaCell-cls1_M-d","cls2":"PremiumCtaCell-cls2_zBY PremiumCtaCell-cls1_M-d"};